import { Component } from '@angular/core';

@Component({
  selector: 'lego-menu-right-item',
  template: '<ng-content></ng-content>'
})
export class MenuRightItemComponent {
}
